jQuery(() => {
  let productWeight = parseFloat($("#product-weight").text());
  let productPrice = parseFloat($("#google-product-price").text());
  let priceLimit = parseFloat("");

  // console.log("Price limit: "+priceLimit)
  // console.log("Product price: "+productPrice)
  // console.log("Product weight: "+productWeight)

  // Weight
  if (productWeight < 0.25) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 0.5) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 1) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 2) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 3) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 4) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 5) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 6) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 7) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 8) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 9) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 10) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 15) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 30) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 40) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 60) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 90) {
    $("#google-shipping-price").html("")
  } else if (productWeight < 120) {
    $("#google-shipping-price").html("")
  }

  //Cart total price
  if(productPrice < priceLimit) {
    $("#google-shipping-price").html("")
  }
})